import React from 'react';
import { IonContent, IonPage, IonImg, IonText} from '@ionic/react';
import { RouteComponentProps} from "react-router-dom";
import { IonGrid, IonRow, IonCol} from '@ionic/react';
import FooterCom from '../components/FooterComponent';
import LoginCheck from "../components/LoginCheck";
import './Dashboard.css';

interface ResetProps
    extends RouteComponentProps<{
        id: string;
    }> { }

const Dashboard: React.FC<ResetProps> = () => {
    return (
        
        <IonPage className="myview">
           <LoginCheck/>
            <IonContent fullscreen className="ion-text-center dash">
                <IonGrid className="dashbody">
                    <IonRow className="yellowtop">
                        
                        <IonCol className='header'>
                            <h1>Explorer Mindset</h1>
                        </IonCol>
                    </IonRow>
                    <IonRow className="vertcenter">
                        <IonImg className="mindsetlogo" src="../assets/images/Explorer-Mindset-App-Logo.png"/>
                        <IonText className="orangeText">V 1.5</IonText>
                        <IonText className="orangeText">Questions contact <a href="https://explorermindset.org" target="_blank" rel="noreferrer">explorermindset.org</a></IonText>
                        <IonText className="greenText">Adventure begins with your mindset</IonText>
                        <IonRow className="contactInfo"><IonCol><IonText className="orangeText inline"><a href="https://explorermindset.org/privacy-policy/" target='_blank' rel="noreferrer">Privacy Policy</a></IonText>
                        </IonCol>
                        <IonCol>
                        <IonText className="inline">&copy; Copyright 2021<br/>www.ExplorerMindset.org</IonText>
                        </IonCol>
                        <IonCol>
                        <IonText className="orangeText inline"><a href="https://explorermindset.org/privacy-policy/" target='_blank' rel="noreferrer" >Terms and Conditions</a></IonText>
                        </IonCol></IonRow>
                       
                    </IonRow>
                </IonGrid>
                <IonRow className="whitebar"></IonRow>
            </IonContent>
            
            <FooterCom/>
        </IonPage>
    );
};

export default Dashboard;
